import React, { useState, useRef, useEffect } from 'react';
import { Delete, Watch, Settings, Move, PlusCircle } from "react-feather";
import { Link } from "@reach/router";
import cx from "classnames";
import { Menu } from 'react-feather';
import { navigate } from '@reach/router';

import styles from "./ListSubcategory.module.scss";

const ListSubcategory = ({ onClick, onDelete, onHide, subcategory }) => {

    const [dropdownVisible, setDropdownVisible] = useState(false);
    const ref = useRef(null);

    const handleClickOutside = (event) => {
        if (ref.current && !ref.current.contains(event.target)) {
            setDropdownVisible(false);
        }
    };

    useEffect(() => {
        document.addEventListener('click', handleClickOutside, true);
        return () =>
            document.removeEventListener('click', handleClickOutside, true);
    }, []);

    const handleHide = (e) => {
        e.stopPropagation();
        setDropdownVisible(false);
        if (onHide) {
            onHide();
        }
    };

    const handleDelete = (e) => {
        e.stopPropagation();
        setDropdownVisible(false);
        if (onDelete) {
            onDelete();
        }
    };

    return (
        <div
            className={styles.writeSubcategoryCard}
            style={{
                backgroundColor: subcategory?.backgroundColor,
                color: subcategory?.textColor,
            }}
        >
            <div className='dropdownHolder'>
                <Menu
                    onClick={(e) => {
                        e.stopPropagation();
                        setDropdownVisible(!dropdownVisible);
                    }}
                    className='dropdownHolder'
                    size='24'
                />

                {dropdownVisible && (
                    <ul ref={ref} className='dropdownMenu dropdownMenuRight'>
                        <li
                            onClick={handleHide}
                            className='dropdownMenuItem'
                        >
                            {subcategory.hidden ? 'Restore' : 'Hide'} subcategory
                        </li>
                        <li
                            onClick={(e) => {
                                e.stopPropagation();
                                setDropdownVisible(false);
                                navigate(`/pack/${subcategory.id}`)
                            }}
                            className='dropdownMenuItem'
                        >
                            Edit subcategory
                        </li>
                        <li
                            onClick={handleDelete}
                            className='dropdownMenuItem'
                            style={{ color: '#ff0000' }}
                        >
                            Delete subcategory
                        </li>
                    </ul>
                )}
            </div>
            <div onClick={onClick}>
                <img
                    className={styles.ImageContainer}
                    src={subcategory.iconUrl}
                    alt="icon-preview"
                />
            </div>
            <div onClick={onClick}>
                <h2>{subcategory.name}</h2>
                <h3>{subcategory.description}</h3>
            </div>
        </div>
    );
};

export default ListSubcategory;